import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import ErrorAwareDatePicker from '../../../../common/inputfields/ErrorAwareDatePicker';
import { FormControlLabel, FormLabel, RadioGroup, Radio } from "@material-ui/core";
import { fmt } from '../../../../../utils/Util';
import axios from "axios";

function addOneDay(date) {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + 1);
    console.log("new date: " + newDate);
    return newDate;
}

export default function ProjectPhaseEndDialogContent({ phase = null, onClose = () => { }, onSuccess = () => { }, onDialogClose = () => { } }) {
    const [isLastPhase, setIsLastPhase] = useState(false);
    const [dialogDate, setDialogDate] = useState(null);
    const [loading, setLoading] = useState(false);

    const shouldDisableDate = (date) => {
        // Disable dates before or equal to phase start date
        const startDate = new Date(phase?.startDate);
        if (date <= startDate) {
            return true;
        }

        // If phase has an end date, disable dates after it
        if (phase?.endDate) {
            const endDate = new Date(phase?.endDate);
            if (date > endDate) {
                return true;
            }
        }

        return false;
    };

    const handleDateChange = (v) => {
        const date = new Date(v);
        const startDate = new Date(phase?.startDate);
        const endDate = phase?.endDate && new Date(phase?.endDate);
        setDialogDate(v);
    };

    const handleApply = async () => {
        if (!dialogDate || !phase.privateId) return;

        setLoading(true);
        try {
            const payload = {
                privateId: phase.privateId,
                endDate: typeof dialogDate === "string" ? dialogDate : dialogDate.toISOString().slice(0, 10),
                shouldCreateNext: !isLastPhase
            };
            console.log(payload);
            await axios.post("/api/customprojectphaseend", payload);

            // notify app to refresh project detail
            window.dispatchEvent(new CustomEvent("projectphase:nextApplied", { detail: { privateId: phase.privateId } }));
            onSuccess();
        } catch (err) {
            console.error("Failed to end project phase", err);
        } finally {
            setLoading(false);
            onClose();
        }
    };

    const formattedCurrentPhaseEnd = dialogDate ? fmt(new Date(dialogDate)) : "'a kiválasztott végdátum'";
    let nextPhaseStart = new Date();
    const currentPhaseEnd = dialogDate && new Date(dialogDate);
    if (currentPhaseEnd?.getDate()) {
        nextPhaseStart = addOneDay(currentPhaseEnd);
    } else {
        nextPhaseStart = null;
    }
    const formattedNextPhaseStart = nextPhaseStart ? fmt(nextPhaseStart) : "'a kiválasztott végdátum + 1'";
    const nextPhaseEnd = phase?.endDate ? fmt(new Date(phase.endDate)) : ""

    return (
        <>
            <div className="project-phase-end-dialog">
                <div className="dialog-form">
                    <ErrorAwareDatePicker
                        label="Végzés dátuma"
                        value={dialogDate}
                        onChange={handleDateChange}
                        required={true}
                        shouldDisableDate={shouldDisableDate}
                    />
                    <div className="radio-group-wrapper">
                        <FormLabel component="legend">Ez az utolsó ütem a projekten?</FormLabel>
                        <RadioGroup
                            row
                            value={isLastPhase ? "yes" : "no"}
                            onChange={(e) => setIsLastPhase(e.target.value === "yes")}
                        >
                            <FormControlLabel value="yes" control={<Radio color="primary" />} label="Igen" />
                            <FormControlLabel value="no" control={<Radio color="primary" />} label="Nem" />
                        </RadioGroup>
                    </div>
                </div>
                <div className="dialog-note">
                    {isLastPhase ? (
                        <>
                            <p>
                                Utolsó ütem a projekten: {phase?.phaseNumber}. ütem {phase?.startDate} - {formattedCurrentPhaseEnd} között.
                            </p>
                            <p>
                                És projekt vége beállítva {formattedCurrentPhaseEnd}
                            </p></>
                    ) : (
                        <p>
                            Egy új ütem lesz létrehozva ({phase?.phaseNumber + 1}. ütem: {formattedNextPhaseStart} - {nextPhaseEnd})
                        </p>
                    )}
                </div>
            </div>

            <DialogActions>
                <Button onClick={onDialogClose}>Mégse</Button>
                <Button
                    color="primary"
                    variant="contained"
                    onClick={handleApply}
                    disabled={!dialogDate || loading}
                >
                    Alkalmaz
                </Button>
            </DialogActions>
        </>
    );
}
